<template>
  <div>
    <a-modal
      :title="dataForm.id ? '编辑账号' : '新增账号'"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form-model
        ref="ruleForm"
        :model="dataForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="账号" prop="username">
          <a-input
            v-model="dataForm.username"
            placeholder="请输入账号（用于登录）"
          />
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password">
          <a-input
            v-model="dataForm.password"
            placeholder="请输入账号密码（用于登录）"
          />
        </a-form-model-item>
        <a-form-model-item
          label="确认密码"
          prop="password2"
          v-if="!dataForm.id"
        >
          <a-input
            v-model="dataForm.password2"
            placeholder="请再次输入账号密码"
          />
        </a-form-model-item>
        <a-form-model-item label="角色" prop="role_id" v-if="is_project != 1">
          <a-select
            v-model="dataForm.role_id"
            placeholder="请选择账号角色"
            @change="roleChange"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option :value="v.id" v-for="v in roles" :key="v.id">
              {{ v.role_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phone">
          <a-input v-model="dataForm.phone" placeholder="请输入联系电话" />
        </a-form-model-item>
        <a-form-model-item label="真实姓名" prop="nickname">
          <a-input v-model="dataForm.nickname" placeholder="请输入真实姓名" />
        </a-form-model-item>
        <a-form-model-item label="邮箱" prop="mail">
          <a-input v-model="dataForm.mail" placeholder="请输入联系邮箱" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { addUser, editUser, userInfo, roleAll } from "@/request/sys";
export default {
  props: {
    //是否是直属账号
    is_project: {
      type: [Number],
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      replaceFields: { children: "children", title: "title", key: "id" },
      roles: [],
      dataForm: {
        id: "",
        username: "", //账号名称
        mail: "",
        phone: "", //联系电话
        password: "",
        password2: "",
        nickname: "",
        disabled: 0,
        role_id: undefined,
      },
      bf: {},
      rules: {
        username: [
          { required: true, message: "请输入登录账号", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入登录账号密码", trigger: "change" },
          { min: 3, max: 20, message: '密码长度为3-20位', trigger: 'blur' },
        ],
        password2: [
          { required: true, message: "请输入再次输入密码", trigger: "change" },
          { min: 3, max: 20, message: '密码长度为3-20位', trigger: 'blur' },
        ],
        role_id: [
          { required: true, message: "请选择账号角色", trigger: "change" },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    init(id = "", project_id = "") {
      this.visible = true;
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      }
      this.dataForm.project_id = project_id;
      roleAll(project_id).then((res) => {
        this.roles = res.data;
      });
    },
    getInfo() {
      userInfo(this.dataForm.id).then((res) => {
        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          role_id: res.data.role_id ? parseInt(res.data.role_id) : "",
        };
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if(this.dataForm.password !== this.dataForm.password2) return this.$message.error("两次密码输入不一致")
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editUser : addUser;
          let form = { ...this.dataForm, is_project: this.is_project };
          //直属行号
          if (this.is_project == 1) {
            form.role_id = 0;
          }
          fn(form)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改账号成功" : "新增账号成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.roles = [];
      this.visible = false;
    },
    //切换角色
    roleChange(e) {
      this.dataForm.role_id = e;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style></style>